import { createI18n } from "vue-i18n";
import { messages, defaultLocale } from "@/i18n/config";
import { Locales } from '@/i18n/config/locales';


export const i18n = createI18n({
  numberFormats: {
    // More info: https://tinyurl.com/s2sjz9cw
    [Locales.en]: {
      currency: {
        style: 'currency', currency: 'USD', notation: 'standard'
      },
      decimal: {
        style: 'decimal', maximumFractionDigits: 2
      },
      percent: {
        style: 'percent', useGrouping: false
      }
    },
    [Locales.nl]: {
      currency: {
        style: 'currency', currency: 'USD', notation: 'standard'
      },
      decimal: {
        style: 'decimal', maximumFractionDigits: 2
      },
      percent: {
        style: 'percent', useGrouping: false
      }
    },
  },
  messages,
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  globalInjection: true,
});

export default i18n;
